import { render, staticRenderFns } from "./DocsUploadToggleStatusModal.vue?vue&type=template&id=1b73c416&scoped=true&"
import script from "./DocsUploadToggleStatusModal.vue?vue&type=script&lang=js&"
export * from "./DocsUploadToggleStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./DocsUploadToggleStatusModal.vue?vue&type=style&index=0&id=1b73c416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73c416",
  null
  
)

export default component.exports